import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

// Self-heal after a deploy: if a JS/CSS chunk is missing (stale bundle
// referencing chunks a new deploy removed), force a one-time hard reload.
const _recoverFromStaleChunk = () => {
  if (sessionStorage.getItem("dmd_chunk_reloaded")) return;
  sessionStorage.setItem("dmd_chunk_reloaded", "1");
  window.location.reload();
};
window.addEventListener("error", (e) => {
  const msg = (e && e.message) || "";
  if (/Loading (CSS )?chunk|ChunkLoadError/i.test(msg)) _recoverFromStaleChunk();
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e && e.reason && (e.reason.message || String(e.reason))) || "";
  if (/Loading (CSS )?chunk|ChunkLoadError/i.test(msg)) _recoverFromStaleChunk();
});
window.addEventListener("load", () => {
  // Successful load -> allow future recovery attempts.
  setTimeout(() => sessionStorage.removeItem("dmd_chunk_reloaded"), 4000);
});
